import { Machine } from "xstate"

import * as userAgent from "../../common/utils/ua"

import * as url from "../../common/utils/url"
import * as configs from "../configs"

import actions from "./actions"
import services from "./services"
import guards from "./guards"

import taskState from "./states/task"
import zoneRoleState from "./states/zoneRole"
import payState from "./states/pay"
import luckyDrawState from "./states/luckydraw"
import fightState from "./states/fight"
import orderAndFightState from "./states/orderAndFight"
import prizeListState from "./states/prizeList"

const machine = Machine({
  id: "appActivity",
  initial: "unknown",
  states: {
    unknown: {
      always: [
        {
          target: "#task.exception.expired",
          cond: context => new Date() >= new Date(context.gameConfig.end_time)
        },
        {
          target: "login"
        }
      ]
    },
    loginPrompt: {
      entry: ["loginPromptReport"]
    },
    welcome: {
      initial: "idle",
      states: {
        idle: {
          entry: "introReport"
        }
      },
      on: {
        CLOSE: "#zoneRole"
      }
    },
    login: {
      initial: "loading",
      states: {
        loading: {
          invoke: {
            id: "login",
            src: "getLoginState",
            onDone: {
              target: "success",
              actions: ["setLoginState", "homepageReport"]
            },
            onError: {
              target: "failure"
            }
          }
        },
        success: {
          always: [
            // {
            //   target: "#appActivity.welcome",
            //   cond: "showWelcome"
            // },
            {
              target: "#appActivity.task"
            }
          ]
        },
        failure: {
          always: [
            {
              cond: "showLoginPrompt",
              target: "#appActivity.loginPrompt"
            },
            {
              actions: ["loginErrorReport"]
            }
          ]
        }
      }
    },
    task: {
      ...taskState
    },
    zoneRole: {
      ...zoneRoleState
    },
    participate: {
      initial: "idle",
      states: {
        idle: {
          on: {
            PLACE_ORDER: [
              {
                target: "pay.forbidden",
                actions: ["buyProductReport"],
                cond: "forbiddenBuy"
              },
              {
                actions: ["savePurchaseInfo", "buyProductReport"],
                target: "pay.preCheck"
              }
            ],
            CLICK_PRESENT: [
              {
                target: "luckydraw.showDrawDialog.first",
                actions: ["setSelectedPresentRank", "setAvailableOpenPresentRank", "clickPresentReport", "resetCouponNum"]
              }
              // {
              //   target: ".luckydraw.showPrizeList",
              //   cond: "hasnotReachedScore",
              //   actions: ["setSelectedPresentRank", "clickPresentReport"]
              // },
              // {
              //   target: ".luckydraw.showAward",
              //   cond: "hasFetchedDrawAward",
              //   actions: ["setSelectedPresentRank", "clickPresentReport"]
              // },
              // {
              //   target: ".luckydraw.receiveTaskPresent",
              //   cond: "hasnotReceivedtaskAward",
              //   actions: ["setSelectedPresentRank", "clickPresentReport"]
              // },
              // {
              //   target: ".luckydraw.getDrawCoupon",
              //   actions: ["setSelectedPresentRank", "clickPresentReport"]
              // }
            ],
            SWITCH_MAP: [
              {
                actions: ["setSelectedMap", "switchMap", "switchMapReport"],
                cond: "hasTaskProgress"
              },
              {
                target: "#appActivity.task",
                actions: ["setSelectedMap", "switchMapReport"]
              }
            ],
            SHOW_FIGHTTASK: [
              {
                target: "fight.freetask",
                actions: "getFreeTaskReport"
              }
            ],
            SELECT_ORDER_OR_FIGHTTASK: [
              {
                target: "orderAndFight.select",
                actions: ["savePurchaseInfo"]
              }
            ]
          }
        },
        pay: {
          ...payState
        },
        luckydraw: {
          ...luckyDrawState
        },
        prizeList: {
          ...prizeListState
        },
        fight: {
          ...fightState
        },
        orderAndFight: {
          ...orderAndFightState
        },
        getOpenlink: {
          invoke: {
            id: "getOpenlink",
            src: "getOpenlink",
            onDone: {
              actions: ["launchOpenlink"]
            },
            onError: {
              actions: ["getOpenLinkErrorReport"]
            }
          }
        }
      },
      on: {
        FETCH_PRIZE_LIST: "#prizeList",
        SHOW_NOW_LIVE: "#appActivity.nowLives",

        SHOW_RULE: "#appActivity.rules",
        GO_STORE: [
          {
            cond: "isInMSDK",
            target: "participate.getOpenlink"
          },
          {
            cond: "IsInQQOrWechat",
            actions: ["redirect"]
          }
        ]
      }
    },
    rules: {
      entry: "rulesReport",
      on: {
        CLOSE_RULE: "participate"
      }
    },
    nowLives: {
      entry: "nowLivesClick",
      on: {
        CLOSE_LIVE: "participate"
      }
    }
  },
  on: {
    REPORT: {
      actions: ["report"]
    }
  }
})

const appMachine = machine.withConfig(
  {
    actions,
    services,
    guards
  },
  {
    busyInterval: 1, //
    busyCount: 10,
    pf: url.getParam("pf"),
    sandbox: url.getParam("sandbox"),
    payEnv: url.getParam("pay_env"),
    gameConfig: configs.GAME_INFO,
    report: configs.REPORT,
    userAgent: userAgent.getUserAgent(),
    availableReceivedRank: "",
    task_token: "",
    taskInfo: "",
    loginState: "",
    zoneList: "",
    selectedZoneId: "",
    selectedZone: "",
    selectedRole: "",
    partitionInfo: "",
    error: "",
    toastMsg: "",
    prizeListRank: "1",
    prizeListShowAll: false,
    prizeList: "",
    winAward: [],
    selectedMap: configs.MAP.JUNIOR,
    tasks: "",
    alertInfo: ""
  }
)

export { appMachine }
